import { useSplitEnabled } from '@buffer-mono/features'
import { ClockIcon, type IconProps, PinIcon } from '@buffer-mono/popcorn'

// Temp hook to centralize some changes across components
export const useDeprecatedPinnedConcept = (): {
  isDeprecated: boolean
  CustomPostIcon: React.ComponentType<IconProps>
} => {
  const { isEnabled: isDeprecated } = useSplitEnabled(
    'remove-pinned-post-concept',
  )

  return {
    isDeprecated,
    CustomPostIcon: isDeprecated ? PinIcon : ClockIcon,
  }
}
